/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B090021 倉庫移動入力(物流業務)
 */

import { Column } from "@material-table/core";
import { Box } from "@mui/material";
import {
  B000111Meisaibiko,
  B000130BumonNm,
  B000140ShainNmBumonCd,
  B000190Ukeiresoko,
  B000200ShohinNmr,
  B090021Create,
  B090021CreateRequest,
  B090021Kanosu,
  B100190Valid,
  B100190ValidRequest,
  catchRestError,
} from "clients/rest";
import {
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  SFileButton,
  SCancelButton,
  msgState,
  SEntryTab,
  SConfirmDialog,
  SConfirmDialogAction,
} from "components";
import { getClientError, getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000111, B000140, B000190, B000200, B000221, B090060 } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, digit, mapIds } from "services";
import { meishoKbn, sokoCd, sokoshubetsuKbn } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  pageId: string;
  idouYmd: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  haraidashilocationCd: string;
  beforechangedlocationCd: string;
  ukeiresokoCd: string;
  ukeiresokoNmr: string;
  ukeiresokoShubetsuKbn: number;
  // 倉庫種別指定用パラメータ
  sokoshubetsuList: string[];
}>;

// 明細入力部
type MeiFields = Partial<{
  // 新規/編集タブ
  tab: boolean;
  shohinCd: string;
  idousu: string;
  shohinNmr: string;
  kanosu: string;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  gyoNo: number;
  shohinCd: string;
  shohinNmr: string;
  kanosu: number;
  idousu: number;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  pageId: "B090021",
  idouYmd: date(),
  shainCd: "",
  shainNm: "",
  bumonCd: "",
  bumonNm: "",
  haraidashilocationCd: "",
  beforechangedlocationCd: "",
  ukeiresokoCd: "",
  ukeiresokoNmr: "",
  ukeiresokoShubetsuKbn: undefined,
  sokoshubetsuList: ["4", "5"],
};

// 明細入力部
const defaultMeiFields: MeiFields = {
  tab: true,
  shohinCd: "",
  idousu: "",
  shohinNmr: "",
  kanosu: "",
  meisaibikoCd: "",
  meisaibiko: "",
  meisaibikoCdBefore: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "4rem", align: "right" },
  { field: "shohinCd", title: "商品コード", width: "10rem" },
  { field: "shohinNmr", title: "商品名", width: "20rem" },
  {
    field: "kanosu",
    title: "可能数　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.kanosu),
  },
  {
    field: "idousu",
    title: "移動数　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.idousu),
  },
  { field: "meisaibikoCd", hidden: true },
  { field: "meisaibiko", title: "明細備考", width: "20rem" },
  { field: "meisaibikoCdBefore", hidden: true },
];

const focusId = "B090021";

export const B090021 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // テーブル管理
  const tableRef = createRef();
  const pageSize = 15;
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // 明細削除ボタンの活性/非活性管理(行選択の有無で判断)
  const isNotSelectDetailRow: boolean = rowData === undefined;
  // 画面遷移
  const navigate = useNavigate();
  // 払出ロケーション変更時の確認ダイアログオープン用
  const [openConfirm, setOpenConfirm] = useState(false);

  // 初期表示
  useEffect(() => {
    // 初期フォーカス
    focus(1);
  }, []);

  // コンポーネント
  // 担当者コード変更
  const handleChangeShainCd = () => {
    (async () => {
      // 担当者名表示処理
      await B000140ShainNmBumonCd(methods, navigate, setMsg);
      // 担当部門表示処理
      await B000130BumonNm(methods, navigate, setMsg);
    })();
  };

  // 商品コード変更
  const handleChangeShohinCd = () => {
    // 商品名表示
    B000200ShohinNmr(meiMethods, navigate, setMsg);
    // 可能数表示
    B090021Kanosu(methods, meiMethods, navigate, setMsg);
  };

  // 払出ロケーション変更確認ダイアログ表示
  const handleOpenConfirm = () => {
    const fields = methods.getValues();
    if (fields.haraidashilocationCd !== fields.beforechangedlocationCd) {
      if (rows.length > 0) {
        setOpenConfirm(true);
      } else {
        handleChangeHaraidashiLocationCd();
      }
    }
  };

  // 払出ロケーション変更キャンセル
  const handleCancelConfirm = () => {
    setOpenConfirm(false);
    const fields = methods.getValues();
    methods.setValue("haraidashilocationCd", fields.beforechangedlocationCd);
  };

  // ロケーションコードBlur処理
  const handleChangeHaraidashiLocationCd = () => {
    // フィールドの値取得
    const fields = methods.getValues();
    handleChangeMeiTab();
    setRows([]);
    setOpenConfirm(false);

    // ロケーションコード存在チェック(存在しない場合可能数クリア)
    if (!fields.haraidashilocationCd) {
      meiMethods.setValue("kanosu", "");
      return;
    }
    // リクエスト作成
    const param: B100190ValidRequest = {
      sokoCd: sokoCd.physicalsokoCd,
      locationCd: fields.haraidashilocationCd!,
    };
    // API呼出し
    B100190Valid(param)
      .then(() => {
        // 可能数表示
        B090021Kanosu(methods, meiMethods, navigate, setMsg);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
    // 変更後のロケーションコードを比較用に保存
    methods.setValue("beforechangedlocationCd", fields.haraidashilocationCd);
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    // タブを編集にする・明細登録(更新)ボタンのラベル変更
    meiMethods.reset();
    meiMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする・明細削除ボタン活性化
    setRowData(rowData);
    // 明細入力部にデータを表示する。
    meiMethods.setValue("shohinCd", rowData.shohinCd);
    meiMethods.setValue("shohinNmr", rowData.shohinNmr);
    meiMethods.setValue("kanosu", rowData.kanosu!.toString());
    meiMethods.setValue("idousu", rowData.idousu!.toString());
    meiMethods.setValue("meisaibikoCd", rowData.meisaibikoCd);
    meiMethods.setValue("meisaibiko", rowData.meisaibiko);
    meiMethods.setValue("meisaibikoCdBefore", rowData.meisaibikoCdBefore);
  };

  // タブ切り替え
  const handleChangeMeiTab = () => {
    // 明細削除ボタン非活性化・行選択解除
    setRowData(undefined);
    // 明細入力部の値を初期化(タブも初期化、明細登録(更新)ボタンのラベルを登録にする)
    meiMethods.reset();
  };

  // 明細削除ボタンクリックイベント
  const handleClickDeteteDetailButton = () => {
    const gyoNo = rowData?.gyoNo;
    // 選択行の削除
    const newRows = rows.filter(function (source: Data) {
      return source.gyoNo !== gyoNo;
    });

    // 明細テーブルの行番号振り直し
    mapIds(newRows, "gyoNo");

    // 削除後のデータセット
    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細入力部の初期化
    meiMethods.reset();

    // タブを新規にする
    meiMethods.setValue("tab", true);
  };

  // 明細登録(更新)ボタンクリックイベント
  const handleClickCreateDetailButton = () => {
    // フィールドの値取得
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 行番号
    const gyoNo: number = rowData?.gyoNo ?? rows.length + 1;

    // 倉庫チェック
    // 1.受入倉庫種別区分が4:返品倉庫、5:その他倉庫以外の場合、エラー
    if (
      !(
        fields.ukeiresokoShubetsuKbn! === sokoshubetsuKbn.henpinSoko ||
        fields.ukeiresokoShubetsuKbn! === sokoshubetsuKbn.othersSoko
      )
    ) {
      setMsg(getClientError("B090021_001"));
      return;
    }

    // 入力チェック
    // 必須の商品コード、移動数入力チェック(無い場合エラー)
    if (meiFields.shohinCd === "" || meiFields.idousu === "") {
      setMsg(getClientError("B090021_002"));
      return;
    }
    // 商品コードが明細テーブル内の商品コードと重複していないかチェック(重複時エラー)
    const isShohinDuplicate: boolean = rows
      .filter(function (source: Data) {
        return source.gyoNo !== gyoNo;
      })
      .some((row) => {
        return row.shohinCd === meiFields.shohinCd;
      });
    if (isShohinDuplicate) {
      setMsg(getClientError("B090021_003"));
      return;
    }
    // 可能数が、可能数＜移動数の場合エラー
    if (Number(meiFields.kanosu!) < Number(meiFields.idousu!)) {
      setMsg(getClientError("B090021_004"));
      return;
    }
    // 移動数が、移動数=<0の場合エラー
    if (Number(meiFields.idousu!) <= 0) {
      setMsg(getClientError("B090021_005"));
      return;
    }

    // タブを参照し登録処理もしくは更新処理を行う。
    if (meiMethods.getValues().tab === true) {
      // 登録
      handleDetailCreate();
    } else {
      // 更新
      handleUpdate();

      // 行選択の解除
      setRowData(undefined);
    }
  };

  // 明細登録処理
  // 明細テーブルに行追加
  const handleDetailCreate = () => {
    meiMethods.handleSubmit(
      () => {
        const gyoNo: number = rows.length + 1;
        const data: Data = handleDataMapping(gyoNo);

        // 明細を設定
        setRows([...rows, data]);
        setRowCount(gyoNo);

        // 明細入力部クリア
        meiMethods.reset();
        focus(5);
      },
      (errors) => {
        console.log(errors);
        setMsg("");
      }
    )();
  };

  // 明細更新処理
  // 明細テーブルの選択行を更新
  const handleUpdate = () => {
    // 明細に設定するデータ取得
    const gyoNo: number = rowData!.gyoNo!;
    const data: Data = handleDataMapping(gyoNo);

    // 明細を設定
    rows[gyoNo - 1] = data;
    setRows([...rows]);

    // 明細入力部クリア
    meiMethods.reset();
  };

  // 明細のデータマッピング
  const handleDataMapping = (gyoNo: number) => {
    // フォームのデータを取得する
    const meiFields = meiMethods.getValues();

    const data: Data = {
      gyoNo,
      shohinCd: meiFields.shohinCd,
      shohinNmr: meiFields.shohinNmr,
      kanosu: Number(meiFields.kanosu!),
      idousu: Number(meiFields.idousu!),
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      meisaibikoCdBefore: meiFields.meisaibikoCdBefore,
    };
    return data;
  };

  // 登録ボタンクリックイベント
  const handleCreate = () => {
    const fields = methods.getValues();

    // 倉庫チェック
    // 1.受入倉庫種別区分が4:返品倉庫、5:その他倉庫以外の場合、エラー
    if (
      !(
        fields.ukeiresokoShubetsuKbn! === sokoshubetsuKbn.henpinSoko ||
        fields.ukeiresokoShubetsuKbn! === sokoshubetsuKbn.othersSoko
      )
    ) {
      setMsg(getClientError("B090021_006"));
      return;
    }

    // 登録リクエスト作成
    const param: B090021CreateRequest = {
      idouYmd: fields.idouYmd!,
      shainCd: fields.shainCd!,
      bumonCd: fields.bumonCd!,
      haraidashilocationCd: fields.haraidashilocationCd!,
      ukeiresokoCd: fields.ukeiresokoCd!,
      soukoIdouList: rows.map((value) => {
        return {
          shohinCd: value.shohinCd!,
          idosu: value.idousu!.toString(),
          meisaibiko: value.meisaibiko,
        };
      }),
    };
    // API呼出し
    B090021Create(param)
      .then(() => {
        methods.reset();
        meiMethods.reset();
        setRows([]);
        setMsg(getClientMessage("B090021_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="倉庫移動入力"
          gridTemplateColumns="9rem 10rem 20rem 2rem 6rem 20rem"
        >
          <SLabel required>移動日</SLabel>
          <SDateField label="移動日" name="idouYmd" required {...register(1)} />
          <Box gridColumn="span 3" />
          <SFileButton
            label={labels.buttons.excelImport}
            align="right"
            dialog={
              <B090060
                pageId={methods.watch("pageId")}
                idouYmd={methods.watch("idouYmd")}
                shainCd={methods.watch("shainCd")}
                bumonCd={methods.watch("bumonCd")}
                haraidashilocationCd={methods.watch("haraidashilocationCd")}
                ukeiresokoCd={methods.watch("ukeiresokoCd")}
              />
            }
            dialogAction="close"
          />

          <SLabel required>担当者</SLabel>
          <STextField
            label="担当者コード"
            name="shainCd"
            size={7}
            required
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);
              methods.setValue("bumonCd", data.bumonCd);
              methods.setValue("bumonNm", data.bumonNm);
            }}
            onBlur={handleChangeShainCd}
            {...register(2)}
          />
          <STextField label="担当者名" name="shainNm" required disabled />
          <Box />
          <SLabel>担当部門</SLabel>
          <STextField label="担当部門" name="bumonNm" disabled />

          <SLabel required>払出ロケーション</SLabel>
          <STextField
            name="haraidashilocationCd"
            label="払出ロケーションコード"
            size={14}
            location
            required
            dialog={<B000221 />}
            handleSubmit={(data: any) => {
              methods.setValue("haraidashilocationCd", data.locationCd);
            }}
            onBlur={handleOpenConfirm}
            {...register(3)}
          />
          <Box gridColumn="span 4" />

          <SLabel required>受入倉庫</SLabel>
          <SNumberField
            label="受入倉庫コード"
            name="ukeiresokoCd"
            code
            size={3}
            required
            dialog={
              <B000190 sokoshubetsuList={methods.watch("sokoshubetsuList")} />
            }
            handleSubmit={(data: any) => {
              methods.setValue("ukeiresokoCd", data.sokoCd);
              methods.setValue("ukeiresokoNmr", data.sokoNmr);
              methods.setValue("ukeiresokoShubetsuKbn", data.sokoshubetsuKbn);
            }}
            onBlur={() => B000190Ukeiresoko(methods, navigate, setMsg)}
            {...register(4)}
          />
          <STextField label="受入倉庫名" name="ukeiresokoNmr" disabled />
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          width={1250}
          height={440}
          rowSelectable={meiMethods.watch("tab")}
          pageSize={pageSize}
        />
      </SFrame>

      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeMeiTab}></SEntryTab>
          <SFrame gridTemplateColumns="4rem 5rem 21rem 6rem 6rem 5rem 10rem 20rem">
            <SLabel required gridColumn="span 2">
              商品コード
            </SLabel>
            <SLabel>商品名</SLabel>
            <SLabel>可能数</SLabel>
            <SLabel required>移動数</SLabel>
            <SLabel gridColumn="span 3">明細備考</SLabel>

            <STextField
              label="商品コード"
              name="shohinCd"
              size={10}
              required
              gridColumn="span 2"
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("shohinNmr", data.shohinNmr);
                handleChangeShohinCd();
              }}
              onBlur={handleChangeShohinCd}
              {...register(5)}
            />
            <STextField label="商品名" name="shohinNmr" size={24} disabled />
            <SNumberField
              label="可能数"
              name="kanosu"
              size={6}
              disabled
              align="right"
            />
            <SNumberField
              label="移動数"
              name="idousu"
              size={6}
              required
              align="right"
              {...register(6)}
            />
            <SNumberField
              label="明細備考コード"
              name="meisaibikoCd"
              code="true"
              size={3}
              dialog={<B000111 meishoKbn={meishoKbn.meisaibiko} />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("meisaibikoCd", data.meishoCd);
                meiMethods.setValue("meisaibiko", data.meishoNm1);
                meiMethods.setValue("meisaibikoCdBefore", data.meishoCd);
              }}
              onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
              {...register(7)}
            />
            <STextField
              label="明細備考"
              name="meisaibiko"
              size={30}
              gridColumn="span 2"
              {...register(8)}
            />

            <SCancelButton
              label={labels.buttons.deleteDetail}
              disabled={isNotSelectDetailRow}
              align="left"
              {...register(10)}
              onClick={handleClickDeteteDetailButton}
            />
            <Box gridColumn="span 6" />
            {meiMethods.getValues().tab === true ? (
              <SNormalButton
                label={labels.buttons.createDetail}
                {...register(11)}
                align="right"
                onClick={handleClickCreateDetailButton}
              />
            ) : (
              <SNormalButton
                label={labels.buttons.updateDetail}
                align="right"
                {...register(11)}
                onClick={handleClickCreateDetailButton}
              />
            )}
          </SFrame>
          <SFrame>
            <SNormalButton
              label={labels.buttons.create}
              align="right"
              {...register(12)}
              dialog={
                <SConfirmDialog
                  title="倉庫移動入力"
                  msg="登録します。よろしいですか？"
                />
              }
              dialogAction="confirm"
              handleSubmit={handleCreate}
            />
          </SFrame>
        </SFrame>
        <SConfirmDialogAction
          msg={labels.dialog.meisaiReset}
          onOk={handleChangeHaraidashiLocationCd}
          onCancel={handleCancelConfirm}
          isOpen={openConfirm}
        />
      </FormProvider>
    </>
  );
};
